module.exports = __webpack_public_path__ + "static/media/NothingScheduled.648dba54.svg";